import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// State
import { setSelectedVariant } from "./../../../store/actions/productVariant";

import Select from "react-select";
import "react-select/dist/react-select.css";

import "./../../../css/react-selectbox.css";

// ===================================================================================
//	Note:
//	API requires variants to be sent as variants[Size-123]: 255
//	variants[variant_title-variant_id]: option_id
// ===================================================================================

class ProductVariant extends Component {
	static propTypes = {
		variant: PropTypes.object,
		onChange: PropTypes.func
	};

	componentWillMount() {
		// Serialize variants so `Select` component can understand then { value: item_id, label: 'some text' }
		this.serializeVariantOptions();

		// console.log("componentWillMount", this.props.product.sku);
		this.props.setSelectedVariant(
			this.props.variant.title + "-" + this.props.variant.id,
			this.props.variant.itemsSerialized[0].value,
			this.props.product
		);
	}

	serializeVariantOptions = () => {
		this.props.variant.itemsSerialized = this.props.variant.items.map((item, j) => {
			return {
				value: item.id,
				label: item.title
			};
		});
	};

	getSelectedOption = variant => {
		return this.props.selectedVariants.find((option, i) => {
			return option.variant_id === variant.title + "-" + variant.id;
		});
	};

	render() {
		const variant = this.props.variant;
		const option = this.getSelectedOption(variant);

		// console.log(option);

		// Ensure option is set
		const option_id = option === undefined ? null : option.option_id;

		return (
			<Select
				name={`${variant.title}-${variant.id}`}
				value={option_id}
				onChange={selection =>
					this.props.setSelectedVariant(
						this.props.variant.title + "-" + this.props.variant.id,
						selection.value,
						this.props.product
					)
				}
				clearable={false}
				options={variant.itemsSerialized}
			/>
		);
	}
}

const mapStateToProps = state => {
	return { selectedVariants: state.productVariant.variant_options };
};

export default connect(mapStateToProps, { setSelectedVariant })(ProductVariant);



// WEBPACK FOOTER //
// ./src/components/product/variants/ProductVariantSelect.js